import locationTypes from './locationsTypes'

const initialState = {
  originLocations: [],
  destinationLocations: [],
  loadingOriginLocations: false,
  loadingDestinationLocations: false,
  loadingOriginPage: false,
  loadingDestinationPage: false,
  noMoreOriginLocations: false,
  noMoreDestinationLocations: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case locationTypes.START_ORIGIN_LOCATIONS_REQUEST : {
      const { offset } = payload
      const originLocations = offset === 0 ? [] : state.originLocations
      const loadingOriginPage = offset === 0
      return {
        ...state,
        loadingOriginLocations: true,
        noMoreOriginLocations: false,
        originLocations,
        loadingOriginPage
      }
    }

    case locationTypes.FETCH_ORIGIN_LOCATIONS_SUCCESS: {
      const { data, offset } = payload
      let originLocations = data
      const noMoreOriginLocations = data.length < 30

      if (offset !== 0) {
        originLocations = [...state.originLocations, ...originLocations]
      }

      return {
        ...state,
        originLocations,
        noMoreOriginLocations,
        loadingOriginLocations: false,
        loadingOriginPage: false
      }
    }

    case locationTypes.FETCH_DESTINATION_LOCATIONS : {
      const { offset } = payload
      const destinationLocations = offset === 0 ? [] : state.destinationLocations
      const loadingDestinationPage = offset === 0
      return {
        ...state,
        loadingDestinationLocations: true,
        noMoreDestinationLocations: false,
        destinationLocations,
        loadingDestinationPage
      }
    }

    case locationTypes.FETCH_DESTINATION_LOCATIONS_SUCCESS: {
      const { data, offset } = payload
      let destinationLocations = data
      const noMoreDestinationLocations = data.length < 30

      if (offset !== 0) {
        destinationLocations = [...state.destinationLocations, ...destinationLocations]
      }

      return {
        ...state,
        destinationLocations,
        noMoreDestinationLocations,
        loadingDestinationLocations: false,
        loadingDestinationPage: false
      }
    }

    default:
      return state
  }
}
